import { Component, OnInit } from '@angular/core';
import frenchi18n from '@assets/i18n/fr.json';
import { WaitOnWebauthNotification } from '@core/usecase/waitOnWebauthNotification';
import { Bank } from '@modules/process/models/bank';
import { ProcessEventService } from '@shared/services/process-event.service';
import { StoreService } from '@shared/services/store.service';
import { TrackerService } from '@shared/services/tracker.service';
import { AccountsService } from '../select-accounts/services/accounts.service';
import { WaitOnExternalBankLoginVM } from './wait-on-external-bank-login.viewmodel';

@Component({
  selector: 'app-wait-on-external-bank-login',
  templateUrl: './wait-on-external-bank-login.component.html',
  styleUrls: ['../../../../shared/css/oney-waiting-container.scss'],
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'max-w-full d-flex flex-col justify-center items-center' },
})
export class WaitOnExternalBankLoginComponent implements OnInit {
  private waitOnExternalBankLoginVM: WaitOnExternalBankLoginVM;

  constructor(
    private processEventService: ProcessEventService,
    private storeService: StoreService,
    private accountService: AccountsService,
    private waitOnWebauthNotification: WaitOnWebauthNotification,
    private tracker: TrackerService
  ) {
    this.waitOnExternalBankLoginVM = new WaitOnExternalBankLoginVM(
      this.processEventService,
      this.storeService,
      this.accountService,
      this.waitOnWebauthNotification
    );
  }

  async ngOnInit() {
    this.tracker.trackPage({ taggingPage: 'WAIT_ON_EXTERNAL_BANK_LOGIN' });
    await this.waitOnExternalBankLoginVM.onInit();
  }

  backToBankChoice(): void {
    this.tracker.trackClick({
      click: frenchi18n.common_cancel,
      taggingPage: 'WAIT_ON_EXTERNAL_BANK_LOGIN',
    });

    this.waitOnExternalBankLoginVM.backToBankChoice();
  }

  get selectedBank(): Bank {
    return this.storeService.getVariableOrThrow('SELECTED_BANK');
  }
}
